var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', {
    staticClass: "match-height"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('form-input-basic')], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('form-input-size')], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('form-input-horizontal-lable-size')], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('form-floating-label')], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('form-input-contextual-states')], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('form-input-validate-tooltips')], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('form-input-datalist')], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('form-input-debounce')], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('form-input-formatter')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }